import { useEffect, useState } from 'react';
import { Dependency } from 'sched';
import { useDatabase } from './useDatabase';

export function useDependencies() {
  const { database } = useDatabase();
  const [dependencies, setDependencies] = useState<Dependency[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!database) {
      setLoading(false);
      return;
    }

    try {
      const deps = database.dependencies();
      setDependencies(deps);
      setError(null);
    } catch (err) {
      console.error('Error fetching dependencies:', err);
      setError('Failed to load dependencies');
    } finally {
      setLoading(false);
    }
  }, [database]);

  return { dependencies, loading, error };
}
